import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`qualityCoverLetterNew/findAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`qualityCoverLetterNew/save`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  delete({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`qualityCoverLetterNew/delete`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
